// global singleton store
// some routes need access to other route's data
// but there's no way to do that unless we put it somewhere else

export default function store() {
  const store = {
    // list of stories fetched from /search
    stories: [],
    // whatever story is being viewed
    story: {},
  }
  this.set = (prop, data) => {
    store[prop] = data
  }
  this.get = (prop) => store[prop]
}
